/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_7_DInputs */

const en_cp_cal_7_d = /** @type {(inputs: Cp_Cal_7_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7-minute pitch, public benchmark, a winner per track.`)
};

const id_cp_cal_7_d = /** @type {(inputs: Cp_Cal_7_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pitch 7 menit, benchmark publik, pemenang per jalur.`)
};

/**
* | output |
* | --- |
* | "7-minute pitch, public benchmark, a winner per track." |
*
* @param {Cp_Cal_7_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_7_d = /** @type {((inputs?: Cp_Cal_7_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_7_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_7_d(inputs)
	return en_cp_cal_7_d(inputs)
});